import { FaWhatsapp } from 'react-icons/fa';
import { usePage } from '@inertiajs/react';
import { PageProps } from '@/types';

const FloatingWhatsApp = () => {
  const { global_data } = usePage<PageProps>().props;
  const phone = global_data.contact.phone.replace(/\D/g, ''); // Remove non-digits
  const whatsappUrl = `https://wa.me/${phone}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 bg-[#25D366] text-white p-4 rounded-full shadow-lg hover:bg-[#128C7E] transition-all duration-300 z-50 group"
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp className="w-6 h-6" />
      <span className="absolute right-full mr-4 bg-white text-gray-800 px-3 py-1 rounded-lg text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap">
        Chat with us
      </span>
    </a>
  );
};

export default FloatingWhatsApp; 